var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, lighten, useTheme } from '@mui/material';
import * as Preact from 'preact';
import * as ActionBar from './M_ActionBar';
import { isSmallScreen } from './domain/theme/breakpoints';
import { ColourWheel } from './icons';
export var Component = function (p) {
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(Preact.Fragment, null, p.onConfigToggle ? (Preact.h(ActionBar.Component, { sx: __assign({}, p.sx) },
        Preact.h(Button, { startIcon: Preact.h(ColourWheel, null), size: isSmall ? 'small' : 'large', color: p.configSelected ? 'primary' : 'secondary', variant: "text", onClick: p.onConfigToggle, sx: {
                backgroundColor: p.configSelected
                    ? lighten(theme.palette.primary.main, 0.9)
                    : '',
            }, "data-testId": "configure-button" }, p.configToggleText))) : null));
};
Component.displayName = 'ActionBarConfigure';
